import {useTranslation} from 'react-i18next'
import {NativeSelect} from '@/components/native-select'
import {TIPOS_DOCUMENTO, type TipoDocumento} from '@/lib/documento'

/** Nativo y no combobox: R3 pide combobox para cardinalidad N; tres opciones cerradas van en `NativeSelect`. */
export function TipoDocumentoSelect({
  value,
  onChange,
  disabled,
  testId,
}: {
  value: TipoDocumento
  onChange: (tipo: TipoDocumento) => void
  disabled?: boolean
  testId: string
}) {
  const {t} = useTranslation()
  return (
    <NativeSelect
      aria-label={t('documento.tipoLabel')}
      className="w-20 shrink-0 font-mono"
      value={value}
      disabled={disabled}
      data-testid={testId}
      onChange={(e) => onChange(e.target.value as TipoDocumento)}>
      {TIPOS_DOCUMENTO.map((tipo) => (
        <option key={tipo} value={tipo}>
          {tipo}
        </option>
      ))}
    </NativeSelect>
  )
}
